import { render } from "./shopMenu.vue?vue&type=template&id=2a3773a6&scoped=true"
import script from "./shopMenu.vue?vue&type=script&lang=js"
export * from "./shopMenu.vue?vue&type=script&lang=js"

import "./shopMenu.vue?vue&type=style&index=0&id=2a3773a6&lang=css"
import "./shopMenu.vue?vue&type=style&index=1&id=2a3773a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3773a6"]])

export default __exports__